<template>
  <div class="dv2-page">
    <div class="dv2-header">
      <div class="dv2-header__top">
        <span class="dv2-header__title">Painel de cotações de compra</span>

        <div class="dv2-header__actions">
          <a-button icon="download" @click="onExport">Exportar</a-button>
          <a-button type="primary" icon="plus" class="dv2-btn-primary" @click="onNewQuote">
            Nova cotação
          </a-button>
        </div>
      </div>

      <!-- Filtros do painel desativados temporariamente: a API real de
           filtros ainda não está disponível (só o mock `getFiltros`).
      <div class="dv2-header__row">
        <span class="dv2-header__row-label">Filtros</span>
        <a-select v-model="selected.period" :options="periodOptions" style="width: 176px" :disabled="filtersLoading" />
        <a-select v-model="selected.company" :options="companyOptions" style="width: 168px" :disabled="filtersLoading" />
        <a-select v-model="selected.branch" :options="branchOptions" style="width: 150px" :disabled="filtersLoading" />
        <a-select v-model="selected.buyer" :options="buyerOptions" style="width: 176px" :disabled="filtersLoading" />
        <a-select v-model="selected.category" :options="categoryOptions" style="width: 180px" :disabled="filtersLoading" />
      </div>

      <div class="dv2-header__row">
        <span class="dv2-header__row-label">Aplicados</span>
        <a-tag
          v-for="tag in appliedTags"
          :key="tag.key"
          closable
          color="orange"
          @close="removeTag(tag.key)"
        >
          {{ tag.label }}
        </a-tag>
        <a href="#" class="dv2-clear-link" @click.prevent="clearFilters">Limpar filtros</a>
      </div>
      -->
    </div>

    <div class="dv2-body">
      <QuotesSection :filters="appliedFilters" />
      <OrdersSection :filters="appliedFilters" />
      <!-- Itens e Fornecedores desativados temporariamente — usar depois. -->
      <!-- <ItemsSection :filters="appliedFilters" /> -->
      <!-- <SuppliersSection :filters="appliedFilters" /> -->
      <BuyersSection :filters="appliedFilters" />
    </div>
  </div>
</template>

<script>
import QuotesSection from './components/QuotesSection.vue';
import OrdersSection from './components/OrdersSection.vue';
import ItemsSection from './components/ItemsSection.vue';
import SuppliersSection from './components/SuppliersSection.vue';
import BuyersSection from './components/BuyersSection.vue';
import DashboardV2Service from '@/services/v3/dashboard/DashboardV2Service';

const service = new DashboardV2Service();

export default {
  name: 'DashboardV2Page',

  components: {
    QuotesSection, OrdersSection, ItemsSection, SuppliersSection, BuyersSection,
  },

  data() {
    return {
      filtersLoading: true,
      periodOptions: [],
      companyOptions: [],
      branchOptions: [],
      buyerOptions: [],
      categoryOptions: [],
      selected: {
        period: null,
        company: null,
        branch: null,
        buyer: null,
        category: null,
      },
      defaults: {},
    };
  },

  computed: {
    // Objeto simples repassado como prop para cada seção — cada seção observa
    // essa referência e refaz sua própria "chamada de API" quando ela muda.
    appliedFilters() {
      return { ...this.selected };
    },

    appliedTags() {
      const tags = [];
      const periodLabel = this.optionLabel(this.periodOptions, this.selected.period);
      if (periodLabel) tags.push({ key: 'period', label: periodLabel });

      if (this.selected.branch && this.selected.branch !== 'todas') {
        tags.push({ key: 'branch', label: `Filial: ${this.optionLabel(this.branchOptions, this.selected.branch)}` });
      }

      if (this.selected.category && this.selected.category !== 'todas') {
        tags.push({ key: 'category', label: `Categoria: ${this.optionLabel(this.categoryOptions, this.selected.category)}` });
      }

      return tags;
    },
  },

  created() {
    // Filtros desativados temporariamente — ver comentário no template.
    // this.fetchFilters();
  },

  methods: {
    fetchFilters() {
      this.filtersLoading = true;
      service.getFiltros().then(({ data }) => {
        this.periodOptions = data.periodOptions;
        this.companyOptions = data.companyOptions;
        this.branchOptions = data.branchOptions;
        this.buyerOptions = data.buyerOptions;
        this.categoryOptions = data.categoryOptions;
        this.selected = { ...data.defaults };
        this.defaults = { ...data.defaults };
        this.filtersLoading = false;
      });
    },

    optionLabel(options, value) {
      const found = options.find((opt) => opt.value === value);
      return found ? found.label : '';
    },

    clearFilters() {
      this.selected = { ...this.defaults };
    },

    removeTag(key) {
      if (key === 'period') this.selected.period = this.defaults.period;
      if (key === 'branch') this.selected.branch = 'todas';
      if (key === 'category') this.selected.category = 'todas';
    },

    onExport() {
      this.$store.dispatch('notification/add', {
        type: 'info',
        message: 'Exportação ainda não disponível nesta prévia.',
      });
    },

    onNewQuote() {
      this.$store.dispatch('notification/add', {
        type: 'info',
        message: 'Fluxo de nova cotação ainda não disponível nesta prévia.',
      });
    },
  },
};
</script>

<style lang="scss">
// Classes de layout compartilhadas pelas seções do dashboard-v2. Ficam aqui,
// sem `scoped`, para serem reaproveitadas pelos componentes de seção sem
// duplicar o mesmo bloco de CSS em cada um deles.
.dv2-grid {
  display: grid;
  gap: 20px;
  align-items: stretch;
}

.dv2-grid--kpi-chart {
  grid-template-columns: 420px 1fr;
}

.dv2-grid--chart-kpi {
  grid-template-columns: 1fr 420px;
}

.dv2-grid--full {
  grid-template-columns: 1fr;
}

@media (max-width: 960px) {
  .dv2-grid--kpi-chart,
  .dv2-grid--chart-kpi {
    grid-template-columns: 1fr;
  }
}
</style>

<style lang="scss" scoped>
.dv2-page {
  background: #F5F2EF;
  min-height: 100%;
  font-family: 'DM Sans', system-ui, sans-serif;
}

.dv2-header {
  background: #fff;
  border-bottom: 1px solid #EFEAE4;
  display: flex;
  flex-direction: column;
}

.dv2-header__top {
  padding: 16px 26px 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.dv2-header__title {
  font-family: 'Baloo 2', 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #212121;
  line-height: 1.1;
}

.dv2-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dv2-btn-primary {
  background: #FF5722;
  border-color: #FF5722;
}

.dv2-header__row {
  padding: 0 26px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.dv2-header__row-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: #9C948C;
  width: 74px;
  flex: none;
}

.dv2-clear-link {
  font-size: 12px;
  font-weight: 600;
  margin-left: 4px;
  color: #FF5722;
}

.dv2-body {
  padding: 22px 26px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dv2-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
